import { SET_EDITCOMPANY } from '../actions';

const companyedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITCOMPANY:
      return [...action.value];  
    default: return state;
  }
}

export default companyedit;
